import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const fetchAllSalaryProfileConfig = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.PAYROLL_SALARYY_PROFILE.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      ret: params.ret,
      ref: params.ref,
      lim: params.limit,
      incl: params.incl,
      useAggregate: params.useAggregate,
      pg: params.page,
      cache: false,
    },
  });
};

export const addSalaryConfigApi = async (coll, payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.PAYROLL_SALARYY_PROFILE.ADD_NEW,
    data: {
      coll: coll,
      payload: payload,
    },
  });
};
export const updateSalaryConfigApi = async (coll, payload, uiid) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.PAYROLL_SALARYY_PROFILE.UPDATE,
    params: {
      coll: coll,
      uiid,
    },
    data: {
      payload,
    },
  });
};
export const fetchEmpPayConfig = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.EMPLOYEE_PAY_CONFIGURATION.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      ret: params.ret,
      ref: params.ref,
      lim: params.limit,
      incl: params.incl,
      pg: params.page,
      sort: JSON.stringify(params.sort),
      cache: false,
      useAggregate: params.useAggregate ? true : false,
    },
  });
};
export const fetchPayrolls = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.PAYROLL.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      ret: params.ret,
      ref: params.ref,
      lim: params.limit,
      incl: params.incl,
      pg: params.page,
      cache: false,
      useAggregate: params.useAggregate ? true : false,
    },
  });
};

// export const addEmpPayConfigApi = async ({
//   coll,
//   payload,
//   createPayroll
// }) => {
export const addEmpPayConfigApi = async (coll, payload, createPayroll) => {
  console.log("createPayroll in api", createPayroll, coll, payload);
  // return;
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.EMPLOYEE_PAY_CONFIGURATION.ADD_NEW,
    data: {
      ...(createPayroll && { postActions: ["CreatePayroll"] }),
      coll: coll,
      payload: payload,
    },
  });
};
// export const addEmpPayConfigApi = async (
//   coll,
//   payload,
//   createPayroll = false
// ) => {
//   return await axiosRequest({
//     method: "POST",
//     url: ENDPOINTS.EMPLOYEE_PAY_CONFIGURATION.ADD_NEW,
//     data: {
//       ...(createPayroll && { postActions: ["CreatePayroll"] }),
//       coll: coll,
//       payload: payload,
//     },
//   });
// };
export const updateEmpPayConfigApi = async (
  coll,
  payload,
  uiid,
  createPayroll
) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.EMPLOYEE_PAY_CONFIGURATION.UPDATE,
    params: {
      coll: coll,
      uiid,
    },
    data: {
      // ...(createPayroll && { postActions: ["CreatePayroll"] }),
      payload,
    },
  });
};
export const fetchEmpDeduction = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.EMPLOYEE_DEDUCTIONS.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      ret: params.ret,
      ref: params.ref,
      lim: params.limit,
      incl: params.incl,
      pg: params.page,
      cache: false,
    },
  });
};

export const addEmpDeductionApi = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.EMPLOYEE_DEDUCTIONS.ADD_NEW,
    data: {
      coll: payload?.coll,
      payload: payload?.payload,
    },
  });
};
export const fetchEmpOtherPayments = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.EMPLOYEE_OTHER_PAYMENTS.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      sort: JSON.stringify(params.sort),
      ret: params.ret,
      ref: params.ref,
      lim: params.limit,
      incl: params.incl,
      pg: params.page,
      cache: false,
    },
  });
};
export const addEmpOtherPaymentsApi = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.EMPLOYEE_OTHER_PAYMENTS.ADD_NEW,
    data: {
      coll: payload?.coll,
      payload: payload?.payload,
    },
  });
};
export const updatePayrollApi = async ({ coll, payload, uiid, preActions }) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.PAYROLL.UPDATE,
    data: {
      ...(preActions && { preActions }),
      payload,
    },
    params: {
      coll,
      uiid,
    },
  });
};
export const updateEmpOtherPaymentsApi = async ({ coll, payload, uiid }) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.EMPLOYEE_OTHER_PAYMENTS.UPDATE,
    data: {
      payload,
    },
    params: {
      coll,
      uiid,
    },
  });
};

export const updateEmpDeductions = async ({ coll, payload, uiid, patchId,preActions=null }) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.EMPLOYEE_DEDUCTIONS.UPDATE,
    data: {
      payload,
      ...(preActions && {preActions}),
    },
    params: {
      coll,
      uiid,
      patchId,
    },
  });
};
// export const updateImmigration = async (uiid, patchId, coll, payload, tPath) => {
//   const queryParams = new URLSearchParams({
//     coll,
//     uiid,
//     ...(patchId && { patchId }),
//     ...(tPath && { tPath }),
//   });
// const url=coll==="LCA"?ENDPOINTS.LCA.UPDATE:coll==="H1B"?ENDPOINTS.H1B.UPDATE:coll==="Visa"?ENDPOINTS.VISA.UPDATE:coll==="JobNAdv"?ENDPOINTS.JOBNADVS.UPDATE: "";
//   return await axiosRequest({
//     method: 'PATCH',
//     url: `${url}?${queryParams.toString()}`,
//     data: { payload },
//   });
// };
